<template>
    <div class="product-banner" :class="`product-banner--${block.type}`">
        <component
            :is="banner.link ? (banner.link.startsWith('http') ? 'a' : 'NuxtLink') : 'div'"
            :to="!banner.link?.startsWith('http') ? banner.link : null"
            :href="banner.link?.startsWith('http') ? banner.link : null"
            class="product-banner__part"
            :style="`aspect-ratio: ${aspectRatio}`"
            v-for="(banner, index) in block.items"
            :key="index">
            <div class="product-banner__content">
                <div v-if="banner.text" class="product-banner__title">
                    <span v-if="block.type === 'promo_three_images'">/ </span>{{ banner.text }}
                </div>
                <div v-if="banner.buttonText" class="button button--secondary text_13">
                    {{ banner.buttonText }}
                </div>
            </div>
            <UiImage :path="getImage(banner)" :mobile="cropSize.mobile" :desktop="cropSize.desktop"></UiImage>
        </component>
    </div>
</template>
<script>
import UiImage from "@/components/ui/Image";
export default {
    name: "ProductBlockBanner",
    components: { UiImage },
    props: {
        block: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {};
    },
    computed: {
        cropSize() {
            if (this.block.type === "promo_three_images") {
                return {
                    desktop: { width: 542, height: 814 },
                    mobile: { width: 240, height: 360 },
                };
            }
            if (this.block.type === "promo_two_banners") {
                return {
                    desktop: { width: 812, height: 325 },
                    mobile: { width: 414, height: 440 },
                };
            }
            return {
                desktop: { width: 1624, height: 650 },
                mobile: { width: 414, height: 550 },
            };
        },
        aspectRatio() {
            const screen = this.$device.isDesktop ? "desktop" : "mobile";
            return this.cropSize[screen].width / this.cropSize[screen].height;
        },
    },
    methods: {
        getImage(banner) {
            if (this.$device.isDesktop) {
                return banner.image.path;
            }
            return banner.mobileImage?.path || banner.image.path;
        },
    },
};
</script>
<style lang="less">
.product-banner {
    padding-top: 32px;
    display: flex;
    & + & {
        padding-top: 0;
    }
    picture {
        filter: brightness(75%);
        -webkit-filter: brightness(75%);
    }
    &__part {
        position: relative;
        flex-grow: 1;
    }
    &__content {
        position: absolute;
        bottom: 32px;
        left: 64px;
        right: 64px;
        color: #fff;
        z-index: 1;
        @media @sm {
            left: 16px;
            right: 16px;
            bottom: 16px;
        }
        .button {
            color: #fff;
        }
    }
    &--promo_three_images {
        overflow-x: auto;
        scroll-snap-type: x mandatory;

        .product-banner {
            &__part {
                scroll-snap-align: start;
                min-width: 240px;
            }
            &__content {
                left: 32px;
                right: 32px;
                @media @sm {
                    left: 16px;
                    right: 16px;
                }
            }
            &__title {
                font-size: 19px;
                line-height: 120%;
                letter-spacing: 0.16em;
                @media @sm {
                    font-size: 15px;
                }
            }
        }
    }
    &--promo_two_banners {
        @media @sm {
            flex-direction: column;
        }
        .product-banner {
            &__content {
                top: 32px;
                display: flex;
                flex-direction: column;
                justify-content: center;
                align-items: flex-start;
                gap: 32px;
                @media @sm {
                    gap: 16px;
                    top: 16px;
                }
            }
            &__title {
                font-size: 28px;
                line-height: 120%;
                letter-spacing: 0.16em;
                @media @sm {
                    font-size: 18px;
                }
            }
        }
    }
    &--promo_wide_banner & {
        &__content {
            top: 32px;
            display: flex;
            flex-direction: column;
            justify-content: flex-end;
            align-items: flex-start;
            gap: 32px;
            @media @sm {
                gap: 16px;
            }
        }
        &__title {
            font-size: 28px;
            line-height: 120%;
            letter-spacing: 0.16em;
            @media @sm {
                font-size: 18px;
            }
        }
    }
}
</style>
